import type { LevelConfig } from '../index';

export const level4: LevelConfig = {
  id: 'level_4',
  stage: '1',
  mapId: 'map_04',
  timeLimitSec: 140,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'collect_coins', target: 20 },
  secondaryObjective: { type: 'find_key', target: 1 },
  enemies: [
    {
      type: 'BASIC_SCAMMER',
      position: { x: 300, y: 350 },
      patrolPath: [
        { x: 300, y: 350 },
        { x: 300, y: 500 },
        { x: 150, y: 500 },
        { x: 150, y: 350 },
      ],
    },
    {
      type: 'BASIC_SCAMMER',
      position: { x: 750, y: 350 },
      patrolPath: [
        { x: 750, y: 350 },
        { x: 750, y: 500 },
        { x: 830, y: 500 },
        { x: 830, y: 350 },
      ],
    },
    {
      type: 'BASIC_SCAMMER',
      position: { x: 400, y: 800 },
      patrolPath: [
        { x: 400, y: 800 },
        { x: 400, y: 870 },
        { x: 250, y: 870 },
        { x: 250, y: 800 },
      ],
    },
    {
      type: 'SUPPORT_SCAMMER',
      position: { x: 700, y: 750 },
      patrolPath: [
        { x: 700, y: 750 },
        { x: 700, y: 870 },
        { x: 830, y: 870 },
        { x: 830, y: 750 },
      ],
    },
  ],
  loot: [
    ...Array.from({ length: 35 }, (_, i) => ({
      type: 'COIN' as const,
      position: {
        x: 160 + (i % 7) * 128,
        y: 160 + Math.floor(i / 7) * 128,
      },
      value: 10,
    })),
    { type: 'QUEST_ITEM', position: { x: 850, y: 150 }, value: 1 },
  ],
  startingWeapon: null,
  startingAmmo: 0,
  unlocks: [],
  challenge: {
    type: 'stealth',
    description: 'Пройди без обнаружения',
    reward: { type: 'boost', amount: 1 },
  },
};
